import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { PushPin } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch } from "react-redux";

import {
  Avatar,
  Container,
  ContainerItem,
  Divider,
  Drawer,
  RadioGroup,
  Text,
} from "../../../../components";
import { palette } from "../../../../theme";
import { POSTTYPES } from "../../../../utils/utils";
import { ReactComponent as PlaceholderImage } from "../../../../assets/placeholderImage.svg";
import { ReactComponent as LikeIcon } from "../../../../assets/like_icon.svg";
import { ReactComponent as CommentIcon } from "../../../../assets/comment_icon.svg";
import PollResult from "./pollResult";
import { showSnackbar } from "../../../../components/snackbar/snackbarSlice";
import { SNACKBAR_TYPES } from "../../../../components/snackbar/snackbarTypes";
import ChallengePostCard from "./challengePostCard";
import { setSelectedPost } from "../../postSlice";
import { useNavigate } from "react-router-dom";

const PostCard = ({
  values,
  previewBannerImage,
  fileRef,
  readOnly,
  onDelete,
  handlePinning,
  isUpdating,
  isEditing,
  openComments,
  disableActions,
}) => {
  const options = values.options
    ? [...values.options].sort((a, b) => b.votes - a.votes)
    : null;

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const menuOptions = [
    { label: "Copy Post ID", value: "copy" },
    {
      label: values.pinned ? "Unpin Post" : "Pin Post",
      value: values.pinned ? "unpin" : "pin",
    },
    { label: "Delete Post", value: "delete" },
  ];

  if (values.type !== POSTTYPES.CHALLENGE) {
    menuOptions.push({ label: "Edit Post", value: "edit" });
  }

  const handleCopyId = () => {
    navigator.clipboard.writeText(values.id);
    dispatch(
      showSnackbar({
        message: "ID copied",
        type: SNACKBAR_TYPES.SNACKBAR_INFO,
      })
    );
  };

  const handlePinClick = (action) => {
    if (handlePinning && !isUpdating) {
      handlePinning(action, values.id);
    }
  };

  const handleDeleteClick = () => {
    if (onDelete) {
      onDelete(true, values.id, values.brand);
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditPost = () => {
    let options = [];
    if (values.type === POSTTYPES.POLL) {
      options = values.options.map((o) => {
        return {
          label: o.text,
          value: o.kind,
        };
      });
    }

    dispatch(setSelectedPost({ ...values, options }));
    navigate("/posts?tab=create");
  };

  const handleMenuItemClick = (value) => {
    switch (value) {
      case "pin":
        handlePinClick("pin");
        break;
      case "unpin":
        handlePinClick("unpin");
        break;
      case "delete":
        handleDeleteClick();
        break;
      case "edit":
        handleEditPost();
        break;
      case "copy":
        handleCopyId();
        break;
      default:
        handleMenuClose();
    }
  };

  return (
    <>
      <Container padding="0" height="fit-content">
        <ContainerItem padding="0" height="fit-content">
          <Box
            sx={{
              backgroundColor: palette.background.white,
              width: "294px",
              height: "fit-content",
              borderRadius: "10px",
            }}
          >
            <Container width="100%" column padding="0">
              <Container
                width="100%"
                align="center"
                padding="16px 0 0 0"
                justify="space-between"
              >
                <ContainerItem
                  flex
                  padding="0"
                  margin="0 0 0 16px"
                  align="center"
                >
                  <Box
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      // navigate(`/brand/${values.brand}`);
                    }}
                  >
                    <Avatar profile_image={values.profileImage} />
                    <Text
                      titleCutoff={20}
                      tooltip
                      tooltipPlacement="top"
                      content={values.profileName ?? "Fitlvl"}
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        color: palette.text.black,
                        marginLeft: "8px",
                      }}
                    />
                  </Box>
                </ContainerItem>
                {readOnly && (
                  <ContainerItem
                    flex
                    margin="0 16px 0 0"
                    padding="0"
                    align="center"
                  >
                    {values.pinned && (
                      <PushPin
                        style={{
                          cursor: "pointer",
                          width: "16px",
                          height: "16px",
                        }}
                        onClick={() => handlePinClick("unpin")}
                      />
                    )}
                    {!disableActions && (
                      <MoreVertIcon
                        sx={{
                          cursor: "pointer",
                          width: "18px",
                          height: "18px",
                        }}
                        onClick={handleMenuClick}
                      />
                    )}
                  </ContainerItem>
                )}
              </Container>
              <ContainerItem flex align="center" padding="16px 0 8px 16px">
                <Text
                  content={values.caption === "_" ? " " : values.caption}
                  sx={{
                    fontWeight: 400,
                    fontSize: "12px",
                    color: palette.text.black,
                    width: "100%",
                  }}
                />
              </ContainerItem>
              {!(values.type === POSTTYPES.POLL && readOnly) && <Divider />}
              {values.type === POSTTYPES.CHALLENGE ? (
                <ChallengePostCard challenge={values.challenge} />
              ) : values.type === POSTTYPES.POLL ? (
                readOnly ? (
                  <ContainerItem padding="0" width="100%">
                    <PollResult
                      result={options}
                      totalVotes={values.totalVotes}
                    />
                  </ContainerItem>
                ) : (
                  <>
                    <ContainerItem
                      padding="0 0 0 18px"
                      height={values.options.length ? "auto" : "320px"}
                    >
                      <RadioGroup options={values.options} />
                    </ContainerItem>
                  </>
                )
              ) : (
                <>
                  <ContainerItem padding="0" width="100%">
                    {isEditing || previewBannerImage ? (
                      <img
                        loading="lazy"
                        src={
                          previewBannerImage
                            ? previewBannerImage
                            : values.banner
                        }
                        alt="Preview"
                        style={{
                          width: "100%",
                          height: "auto",
                        }}
                      />
                    ) : (
                      <PlaceholderImage
                        style={{
                          backgroundColor: palette.background.white,
                          width: "100%",
                          height: "270px",
                          margin: "0",
                          objectFit: "cover",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (!readOnly) {
                            fileRef.current.click();
                          }
                        }}
                      />
                    )}
                  </ContainerItem>
                </>
              )}
              {values.type !== POSTTYPES.POLL && (
                <>
                  <Divider />
                  <Container
                    padding="14px 18px"
                    flex
                    align="center"
                    justify="space-between"
                    width="90%"
                  >
                    <ContainerItem padding="0" flex align="center">
                      <LikeIcon />
                      <Text
                        content={
                          readOnly
                            ? `${values.counts.like ?? 0}${
                                values.counts.like === 1 ? " Like" : " Likes"
                              }`
                            : "Likes"
                        }
                        sx={{
                          fontWeight: 400,
                          fontSize: "12px",
                          color: palette.text.darkGray,
                          marginLeft: "8px",
                        }}
                      />
                    </ContainerItem>
                    <ContainerItem padding="0" flex align="center">
                      <Box
                        onClick={() => {
                          if (!disableActions && openComments) {
                            openComments(values);
                          }
                        }}
                        sx={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <CommentIcon
                          style={{ height: "20px", width: "20px" }}
                        />
                        <Text
                          content={
                            readOnly
                              ? `${values.counts.comment ?? 0}${
                                  values.counts.comment === 1
                                    ? " Comment"
                                    : " Comments"
                                }`
                              : "Comments"
                          }
                          sx={{
                            fontWeight: 400,
                            fontSize: "12px",
                            color: palette.text.darkGray,
                            marginLeft: "8px",
                          }}
                        />
                      </Box>
                    </ContainerItem>
                  </Container>
                </>
              )}
            </Container>
          </Box>
        </ContainerItem>
        <Menu open={open} anchorEl={anchorEl} onClose={handleMenuClose}>
          {menuOptions.map((o, index) => {
            return (
              <MenuItem
                autoFocus={false}
                key={index}
                onClick={(e) => {
                  handleMenuItemClick(o.value);
                  handleMenuClose();
                }}
              >
                {o.label}
              </MenuItem>
            );
          })}
        </Menu>
      </Container>
    </>
  );
};

export default React.memo(PostCard);
